module.exports = __webpack_public_path__ + "static/media/terra.0b8b6d54.png";